import classNames from 'classnames';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SaveIcon from 'mdi-react/ContentSaveOutlineIcon';
import DeleteIcon from 'mdi-react/DeleteOutlineIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import RotateRightIcon from 'mdi-react/RotateRightIcon';
import RotateLeftIcon from 'mdi-react/RotateLeftIcon';
import DownloadIcon from 'mdi-react/DownloadIcon';
import FaceMale from 'mdi-react/FaceIcon';
import MenuRightIcon from 'mdi-react/MenuRightIcon';
import MenuLeftIcon from 'mdi-react/MenuLeftIcon';
import CalendarRefreshIcon from 'mdi-react/CalendarRefreshIcon';
import DataBaseRefreshIcon from 'mdi-react/DatabaseRefreshOutlineIcon';

import styles from './TopBorderBtn.module.scss';

type IconName =
  | 'delete'
  | 'save'
  | 'close'
  | 'download'
  | 'rotateRight'
  | 'rotateLeft'
  | 'A4'
  | 'A6'
  | 'face'
  | 'left'
  | 'right'
  | 'calendarRefresh'
  | 'databaseRefresh';

interface Variants {
  [key: string]: React.ReactNode;
}

const VARIANTS = {
  face: <FaceMale />,
  delete: <DeleteIcon />,
  save: <SaveIcon />,
  rotateRight: <RotateRightIcon />,
  rotateLeft: <RotateLeftIcon />,
  close: <CloseIcon />,
  download: <DownloadIcon />,
  A4: <h5 className="mb-0 mx-1 text-center">A4</h5>,
  A6: <h5 className="mb-0 mx-1 text-center">A6</h5>,
  right: <MenuRightIcon />,
  left: <MenuLeftIcon />,
  calendarRefresh: <CalendarRefreshIcon size={12} />,
  databaseRefresh: <DataBaseRefreshIcon size={12} />,
} as Variants;

const BTN_TOOLTIPS = {
  face: 'Face ID',
  delete: 'Видалити',
  save: 'Зберегти',
  download: 'Завантажити на компьютер',
  rotateRight: 'Повернути праворуч',
  rotateLeft: 'Повернути ліворуч',
  close: 'Закрити',
  A4: 'Розмір фото формату А4',
  A6: 'Розмір фото формату А6',
  right: 'Наступна',
  left: 'Попередня',
  calendarRefresh: 'Cьогодні',
  dataBaseRefresh: 'Оновити дані',
} as Variants;

type Props = {
  icon: IconName;
  clickHandler?: () => void;
  disabled?: boolean;
  className?: string;
  tooltip?: string;
};

const TopBorderBtn: React.FC<Props> = ({ icon, clickHandler, tooltip, disabled = false, className = '' }) => (
  <OverlayTrigger
    key={icon}
    placement="top"
    // eslint-disable-next-line
    overlay={disabled ? <span /> : <Tooltip id={`tooltip-${icon}`}>{tooltip ? tooltip : BTN_TOOLTIPS[icon]}</Tooltip>}
  >
    <Button
      className={classNames('p-1', styles.btn, styles[icon], className)}
      variant="light"
      disabled={disabled}
      {...(clickHandler && { onClick: clickHandler })}
    >
      {VARIANTS[icon]}
    </Button>
  </OverlayTrigger>
);

export default TopBorderBtn;
